import angular from 'angular';

import CategoryColorChartModule from './category-color-chart';
import CategoryGroupModule from './category-group';
import EventGroupModule from './event-group';

export default angular
    .module('application.scene.authorized.scene.calendar.component.calendar-dashboard.component', [
        CategoryColorChartModule.name,
        CategoryGroupModule.name,
        EventGroupModule.name
    ]);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-dashboard/component/index.js